// extracted by mini-css-extract-plugin
export default {"ConfirmModal-Warning-Header":"ConfirmModal_ConfirmModal-Warning-Header__HxXyZ"};